import React from 'react'
import { useForm } from '@inertiajs/react'
import UserLayout from '../../Layouts/UserLayout'
import useTranslation from '../../hooks/useTranslation'

const LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'fr', name: 'Français' },
  { code: 'es', name: 'Español' },
  { code: 'de', name: 'Deutsch' },
  { code: 'it', name: 'Italiano' },
  { code: 'pt', name: 'Português' },
  { code: 'ru', name: 'Русский' },
  { code: 'ja', name: '日本語' },
  { code: 'zh', name: '中文' }
]

export default function Settings({ auth }) {
  const { t } = useTranslation()
  const { data, setData, put, processing, errors, recentlySuccessful } = useForm({
    native_language: auth.user.native_language,
    learning_language: auth.user.learning_language
  })

  function submit(e) {
    e.preventDefault()
    put('/settings')
  }

  return (
    <UserLayout>
      <div className="max-w-2xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">{t('settings.title')}</h1>
          <p className="text-gray-600 mt-2">{t('settings.subtitle')}</p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          <div className="p-6 border-b border-gray-100 bg-gray-50">
            <h2 className="text-lg font-semibold text-gray-900">{t('settings.language_preferences')}</h2>
            <p className="text-sm text-gray-500">{t('settings.preferences_description')}</p>
          </div>
          
          <form onSubmit={submit} className="p-6 space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Native Language */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">{t('settings.native_language')}</label>
                <select
                  value={data.native_language}
                  onChange={e => setData('native_language', e.target.value)}
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500 sm:text-sm p-2 border"
                >
                  {LANGUAGES.map(lang => (
                    <option key={lang.code} value={lang.code}>{lang.name}</option>
                  ))}
                </select>
                <p className="mt-1 text-xs text-gray-500">{t('settings.native_language_help')}</p>
              </div>

              {/* Learning Language */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">{t('settings.learning_language')}</label>
                <select
                  value={data.learning_language}
                  onChange={e => setData('learning_language', e.target.value)}
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500 sm:text-sm p-2 border"
                >
                  {LANGUAGES.map(lang => (
                    <option key={lang.code} value={lang.code}>{lang.name}</option>
                  ))}
                </select>
                <p className="mt-1 text-xs text-gray-500">{t('settings.learning_language_help')}</p>
              </div>
            </div>

            {/* Success Message */}
            {recentlySuccessful && (
              <div className="bg-emerald-50 text-emerald-700 p-3 rounded-md text-sm flex items-center gap-2">
                <span>✓</span> {t('settings.success_message')}
              </div>
            )}

            <div className="flex justify-end pt-4 border-t border-gray-100">
              <button
                type="submit"
                disabled={processing}
                className="bg-emerald-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-emerald-700 transition-colors disabled:opacity-50"
              >
                {processing ? t('settings.saving') : t('settings.save_changes')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </UserLayout>
  )
}

